import styled from '@emotion/styled';

export const DataUploadMergePage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 1rem;
`;

export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
